// API response interfaces
export interface ApiResponse<T = any> {
  success?: boolean;
  data?: T;
  message?: string;
  results?: T[];
  [key: string]: any;
}

// Simple fetch API utility with error handling
export const fetchApi = async (url: string, options: RequestInit = {}): Promise<ApiResponse> => {
  try {
    const response = await fetch(`/api/${url}`, {
      credentials: 'include',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        ...options.headers,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Check if the response is JSON
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      const text = await response.text();
      console.error(`Expected JSON but got ${contentType}:`, text.substring(0, 200));
      throw new Error(`Server returned ${contentType} instead of JSON`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Fetch API error:', error);
    throw error;
  }
};